import * as swcHelpers from '@swc/helpers';
import { format, isSameMinute as isSameMinute$1, isSameDay as isSameDay$1, isBefore as isBefore$1, isWithinInterval, eachDayOfInterval, addYears, addMonths, addWeeks, addDays, parseISO } from 'date-fns';
import Cookie from 'js-cookie';
import qs from 'qs';
import ispo from 'lodash/isPlainObject';
export { compose, getDisplayName } from 'recompose';
import * as React from 'react';
import React__default, { useEffect, useRef, useState, useLayoutEffect } from 'react';
import deburr from 'lodash/deburr';
import AbortControllerPolyfill from 'abort-controller';
import { Type, optional, verify } from 'specified';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';
import parse$1, { domToReact as domToReact$1 } from 'html-react-parser';
export { Element } from 'html-react-parser';

// TODO: refactor to use `formatDate`
const dateToDayAndNumberString = (date)=>format(date, 'EEEE d')
;
const dateToDayNumberMonthYearString = (date)=>format(date, 'EEEE d MMMM, yyyy')
;
const dateToLocalTime = (date, timeFormat = '24h')=>timeFormat === 'amPm' ? format(date, 'h:mma') : format(date, 'H:mm')
;
const datesToLocalTimeSpan = (from, until, timeFormat = '24h')=>`${dateToLocalTime(from, timeFormat)} - ${dateToLocalTime(until, timeFormat)}`
;
/**
 * @deprecated Use dateToLocalTime
 */ const dateToShortTime = (date)=>dateToLocalTime(date)
;
const isSameMinute = (date1, date2)=>isSameMinute$1(date1, date2)
;
const isSameDay = (date1, date2)=>isSameDay$1(date1, date2)
;
const isBefore = (date1, date2)=>isBefore$1(date1, date2)
;
const isDateBefore = (date1, date2)=>new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0)
;
const sortDesc = (left, right)=>right.getTime() - left.getTime()
;
const isWithinTimeSpan = (date, start, end)=>isWithinInterval(date, {
        start,
        end
    })
;
/**
 * Serialize a Date as a local ISO8601 datetime string. Like Date.prototype.toISOString,
 * but in the local timezone and without the timezone offset.
 */ const toLocalDateTime = (date)=>format(date, "yyyy-MM-dd'T'HH:mm:ss")
;
/**
 * Serialize a Date as a local ISO8601 datetime string. Like Date.prototype.toISOString,
 * but in the local timezone and with the timezone offset.
 */ const toLocalDateTimeTimeZone = (date)=>format(date, "yyyy-MM-dd'T'HH:mm:ss:xxx")
;
/**
 * Serialize a Date as a local ISO8601 date string. Like Date.prototype.toISOString,
 * but in the local timezone and just the date, no time or timezone offset.
 */ const toLocalDate = (date)=>format(date, 'yyyy-MM-dd')
;
const eachDay = (start, end)=>eachDayOfInterval({
        start,
        end
    })
;
const shiftDate = (date, period, amount = 1)=>{
    switch(period){
        case 'day':
            return addDays(date, amount);
        case 'week':
            return addWeeks(date, amount);
        case 'month':
            return addMonths(date, amount);
        case 'year':
            return addYears(date, amount);
    }
};
const getDateListFromDate = (date, size = 7)=>eachDay(date, shiftDate(date, 'day', size - 1))
;
const pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
const parseLocalDateTime = (input)=>{
    if (!pattern.test(input)) {
        throw new Error(`Invalid local datetime string: ${input}`);
    }
    return parseISO(input);
};
const minutesToHM = (value, locale)=>{
    const baseSettings = {
        style: 'unit',
        notation: 'compact',
        compactDisplay: 'short'
    };
    if (value === 0) {
        return Intl.NumberFormat(locale, swcHelpers.objectSpread({}, baseSettings, {
            unit: 'minute'
        })).format(value);
    }
    const hours = Math.floor(value / 60);
    const minutes = Math.floor(value % 60);
    const hDisplay = hours > 0 ? Intl.NumberFormat(locale, swcHelpers.objectSpread({}, baseSettings, {
        unit: 'hour'
    })).format(hours) : '';
    const mDisplay = minutes > 0 ? Intl.NumberFormat(locale, swcHelpers.objectSpread({}, baseSettings, {
        unit: 'minute'
    })).format(minutes) : '';
    return `${hDisplay} ${mDisplay}`.trim();
};

var dateUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  dateToDayAndNumberString: dateToDayAndNumberString,
  dateToDayNumberMonthYearString: dateToDayNumberMonthYearString,
  dateToLocalTime: dateToLocalTime,
  datesToLocalTimeSpan: datesToLocalTimeSpan,
  dateToShortTime: dateToShortTime,
  isSameMinute: isSameMinute,
  isSameDay: isSameDay,
  isBefore: isBefore,
  isDateBefore: isDateBefore,
  sortDesc: sortDesc,
  isWithinTimeSpan: isWithinTimeSpan,
  toLocalDateTime: toLocalDateTime,
  toLocalDateTimeTimeZone: toLocalDateTimeTimeZone,
  toLocalDate: toLocalDate,
  eachDay: eachDay,
  shiftDate: shiftDate,
  getDateListFromDate: getDateListFromDate,
  parseLocalDateTime: parseLocalDateTime,
  minutesToHM: minutesToHM
});

const getEnvironmentValues = (env, { prefix , notMatching  })=>Object.keys(env).filter((e)=>e.startsWith(prefix) && e.indexOf(notMatching) < 0 && env[e] !== 'false' && env[e]
    ).map((e)=>e.substring(prefix.length)
    )
;
const parseEnvironmentString = (str)=>str.split(';').filter((kv)=>kv.includes('=')
    ).map((kv)=>kv.split(/=(.*)/)
    ).reduce((bi, kv)=>{
        bi[kv[0]] = kv[1];
        return bi;
    }, {})
;
const getFeatures = (prefix = 'FEATURE_', notMatching = 'FEATURE_CONFIGURATION_')=>getEnvironmentValues(process.env, {
        prefix,
        notMatching
    })
;
const getFeatureConfigs = (prefix = 'FEATURE_CONFIGURATION_')=>{
    const configs = {};
    const env = process.env;
    const configsKeys = Object.keys(env).filter((e)=>e.startsWith(prefix) && env[e] !== 'false' && env[e]
    );
    configsKeys.forEach((key)=>configs[key.substring(prefix.length)] = env[key]
    );
    return configs;
};
const getBuildInfo = (name = 'BUILD_INFO')=>parseEnvironmentString(process.env[name] || '')
;

var environmentUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFeatures: getFeatures,
  getFeatureConfigs: getFeatureConfigs,
  getBuildInfo: getBuildInfo
});

function parseCookieString(cookieString) {
    return cookieString.split('; ').map((pair)=>pair.split('=')
    ).reduce((m, [name, value])=>swcHelpers.objectSpread({}, m, {
            [name]: value
        })
    , {});
}

var cookies = /*#__PURE__*/Object.freeze({
  __proto__: null,
  parseCookieString: parseCookieString
});

var DistanceUnit;
(function(DistanceUnit) {
    DistanceUnit["km"] = "km";
    DistanceUnit["meter"] = "meter";
    DistanceUnit["mile"] = "mile";
})(DistanceUnit || (DistanceUnit = {}));

const isLocalizedRequest = (request)=>{
    return 'locale' in request;
};

/**
 * Utility functions to manage all the Locale related tasks
 */ const LOCALE_REGEX = /[a-z]{2}(_|-)[A-Z]{2}/g // Regex to validate locale from a string input
;
const LOCALE_COOKIE_NAME = 'selected_locale' // Cookie name to store the locale setting in a browser cookie
;
function getLocale(req, defaultLocale, isCmsPreview = false) {
    const locale = isLocalizedRequest(req) ? isCmsPreview ? getLocaleFromUrl(req.url) : getLocaleFromUrlOrReq(req) : defaultLocale;
    return locale || defaultLocale;
}
function getLocaleFromUrlOrReq(req) {
    return getLocaleFromUrl(req.url) || getLocaleFromRequest(req);
}
function getLocaleFromRequest(req) {
    return req && req.locale && `${req.locale.language}-${req.locale.region}`;
}
function getLocaleFromCookie() {
    return Cookie.get(LOCALE_COOKIE_NAME);
}
function getLocaleFromUrl(url) {
    const urlWithoutParams = url && url.split('?')[0];
    const locale = urlWithoutParams && urlWithoutParams.split('/').find((part)=>isValidLocale(part)
    );
    return locale && locale.replace('_', '-');
}
function setLocaleToCookie(locale) {
    const expiryDate = new Date(Date.now());
    expiryDate.setFullYear(expiryDate.getFullYear() + 2);
    Cookie.set(LOCALE_COOKIE_NAME, locale, {
        expires: expiryDate
    });
}
function isValidLocale(locale) {
    return !!locale.match(LOCALE_REGEX) && locale.length === 5;
}
function getLocaleSwitchPath(basePath) {
    const urlParts = window.location.href.split('?');
    return urlParts && urlParts.length > 1 ? `${basePath}?${urlParts[1]}` : basePath;
}

var localeUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOCALE_REGEX: LOCALE_REGEX,
  LOCALE_COOKIE_NAME: LOCALE_COOKIE_NAME,
  getLocale: getLocale,
  getLocaleFromUrlOrReq: getLocaleFromUrlOrReq,
  getLocaleFromRequest: getLocaleFromRequest,
  getLocaleFromCookie: getLocaleFromCookie,
  getLocaleFromUrl: getLocaleFromUrl,
  setLocaleToCookie: setLocaleToCookie,
  isValidLocale: isValidLocale,
  getLocaleSwitchPath: getLocaleSwitchPath
});

const isArray = (value)=>Array.isArray(value)
;
const isBoolean = (value)=>typeof value === 'boolean'
;
const isNil = (value)=>value == null
;
const isNumber = (value)=>typeof value === 'number' && Number.isFinite(value)
;
const isPlainObject = (obj)=>ispo(obj)
;
const isString = (value)=>typeof value === 'string'
;
const isFunction = (value)=>typeof value === 'function'
;
const isPresent = (value)=>value !== undefined && value !== null
;
const isDefined = (value)=>value !== undefined
;
const isNotNull = (value)=>value !== null
;

const parse = (urlPart, ignoreQueryPrefix = false)=>qs.parse(urlPart.substring(urlPart.indexOf('?') + 1), {
        ignoreQueryPrefix
    })
;
const stringify = (params, noQuestionMark = false, keyDivision = '&', valueDivision = '=', encode = true)=>valueDivision === '=' ? `${noQuestionMark ? '' : '?'}${qs.stringify(params, {
        delimiter: keyDivision,
        arrayFormat: 'comma',
        encode
    })}` : Object.entries(params).reduce((acc, [key, value], index)=>`${acc}${!index ? noQuestionMark ? '' : '?' : keyDivision}${key}${valueDivision}${value}`
    , '')
;
const toQueryParams = (params, noQuestionMark = false)=>Object.entries(params).reduce((acc, [key, value], index)=>`${acc}${!index ? noQuestionMark ? '' : '?' : '&'}${key}=${isString(value) ? value : stringify(value, true, '|', ':')}`
    , '')
;

var query = /*#__PURE__*/Object.freeze({
  __proto__: null,
  parse: parse,
  stringify: stringify,
  toQueryParams: toQueryParams
});

function upFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  upFirst: upFirst
});

const guard = (fieldName, value, defaultValue)=>{
    if (!value && isString(defaultValue)) {
        return defaultValue;
    }
    if (isString(value)) {
        return value;
    }
    throw new Error(`${fieldName}: value ${value} is not a string`);
};

var stringGuard = /*#__PURE__*/Object.freeze({
  __proto__: null,
  guard: guard
});

const checkForNum = (formatter)=>(value)=>{
        if (!isPresent(value) || typeof value === 'number' && isNaN(value)) {
            return undefined;
        }
        return formatter(value);
    }
;
const decimalFormatter = (v)=>v.toFixed(2)
;
const defaultFormatter = checkForNum((v)=>typeof v === 'number' ? `${v > 0 ? '+' : ''}${decimalFormatter(v)}` : v
);
const basicFormatter = checkForNum((v)=>v.toString()
);
const specificFormatters = {
    pupillaryDistance: basicFormatter,
    axis: basicFormatter,
    addition: basicFormatter
};
var _attributeName;
const getFormatter = (attributeName)=>(_attributeName = specificFormatters[attributeName]) !== null && _attributeName !== void 0 ? _attributeName : defaultFormatter
;
const formatPrescriptionValue = (name, value)=>getFormatter(name)(value)
;

var formatPrescriptionValue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFormatter: getFormatter,
  formatPrescriptionValue: formatPrescriptionValue
});

const isRealLocation = (p)=>typeof p.lat === 'number' && typeof p.lon === 'number' && p.lat >= -90 && p.lat <= 90 && p.lon >= -180 && p.lon <= 180
;

const rad = (degrees)=>degrees * Math.PI / 180
;
const deg = (radians)=>radians * 180 / Math.PI
;

const RADIUS = 6371000 // earth radius in meters
;
const { sin: sin$1 , cos: cos$1 , atan2: atan2$1 , sqrt: sqrt$1 , PI: PI$1  } = Math;
/**
 * Calculate the geodesic distance in meters between two points on earth using
 * the haversine formula (rounded to the nearest meter). Can return Infinity if
 * either point has missing or invalid coordinates.
 */ function getDistance(start, end) {
    if (!isRealLocation(start) || !isRealLocation(end)) {
        return Infinity;
    }
    const dLat = rad(end.lat - start.lat);
    const dLon = rad(end.lon - start.lon);
    const a = sin$1(dLat / 2) * sin$1(dLat / 2) + sin$1(dLon / 2) * sin$1(dLon / 2) * cos$1(rad(start.lat)) * cos$1(rad(end.lat));
    const c = 2 * atan2$1(sqrt$1(a), sqrt$1(1 - a));
    return Math.round(RADIUS * c);
}

const { sin , cos , atan2 , sqrt , PI  } = Math;
/**
 * Calculate the average coordinates of a list of points. Points with
 * invalid coordinates are ignored. Returns `null` if none of the points
 * have valid coordinates.
 */ const getCenter = (points)=>{
    if (!points.length) {
        return null;
    }
    let x = 0;
    let y = 0;
    let z = 0;
    let n = 0;
    points.forEach((point)=>{
        if (isRealLocation(point)) {
            const lat = rad(point.lat);
            const lon = rad(point.lon);
            x += cos(lat) * cos(lon);
            y += cos(lat) * sin(lon);
            z += sin(lat);
            n += 1;
        }
    });
    if (n === 0) {
        return null;
    }
    x /= n;
    y /= n;
    z /= n;
    return {
        lat: deg(atan2(z, sqrt(Math.pow(x, 2) + Math.pow(y, 2)))),
        lon: deg(atan2(y, x))
    };
};

const WithUserCoords = ({ children , onUserCoords , onError , labels  })=>{
    const hasBrowserSupport = typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && typeof window.navigator.geolocation !== 'undefined';
    const getUserCoords = hasBrowserSupport ? ()=>getCoords(onUserCoords, onError, labels)
     : ()=>undefined
    ;
    return children && children({
        hasBrowserSupport,
        getUserCoords
    });
};
function getCoords(callback, handleError, labels) {
    navigator.geolocation.getCurrentPosition((position)=>{
        callback(position.coords);
    }, (error)=>{
        console.warn('Failed to get user coords:', error);
        switch(error.code){
            case error.PERMISSION_DENIED:
                handleError(labels.yourLocationPermission);
                break;
            default:
                handleError(labels.yourLocationError);
        }
    });
}

const useScrollIntoView = (defaultScrollOptions)=>{
    const elementRef = React.useRef(null);
    const triggerScroll = React.useCallback((overrideOptionsPerScroll)=>{
        if (!elementRef.current) {
            return;
        }
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        elementRef.current.scrollIntoView(swcHelpers.objectSpread({
            behavior: prefersReducedMotion ? 'auto' : 'smooth'
        }, defaultScrollOptions, overrideOptionsPerScroll));
    }, [
        defaultScrollOptions
    ]);
    return {
        elementRef,
        triggerScroll
    };
};

function useDebouncedEffect(fn, delay, deps = []) {
    useEffect(()=>{
        const id = setTimeout(fn, delay);
        return ()=>clearTimeout(id)
        ;
    }, [
        delay,
        ...deps
    ]);
}

function useEventListener(type, listener) {
    const refHandler = useRef(listener);
    /**
   * Make use of ref.current if the listener changes.
   * This ref updates the handler when it is changed without having to add it to the dependencies in the eventlistener effect
   * this in turn removes many potential re-runs of the effect which would result in many add/remove listeners to the dom.
   */ useEffect(()=>{
        refHandler.current = listener;
    }, [
        listener
    ]);
    useEffect(()=>{
        const isSupported = window && window.addEventListener;
        if (!isSupported) {
            console.warn('Event target does not have an addEventListener method');
            return;
        }
        const handler = (event)=>refHandler.current(event)
        ;
        window.addEventListener(type, handler);
        return ()=>{
            window.removeEventListener(type, handler);
        };
    }, [
        type
    ]);
}

/**
 * withPlusSign
 *
 * Appends a plus sign to positive numbers of string type
 */ function withPlusSign(value) {
    const castValue = +value;
    return isNaN(castValue) || castValue <= 0 ? value : `+${value}`;
}

var unspaceString = ((value)=>value.replace(/\s+/g, '')
);

const slugify = (string)=>{
    return deburr(string) // remove diacritics
    .toLowerCase() // make it all lowercase
    .trim() // remove whitespace before and after
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    ;
};

var replaceWhitespace = ((value, replace)=>value.replace(/\s+/g, replace)
);

const placeholderImage = {
    url: 'https://static-grandvision.imgix.net/grandvision/fallback.png',
    label: '',
    dimensions: {
        h: 0,
        w: 0
    }
};

// Packshot image type
const FRONT_IMAGE = 'Front';
/**
 * Returns Front image if it's set, otherwise placeholder image
 */ function getFrontImage(images) {
    if (!isPresent(images)) return placeholderImage;
    var ref;
    const image1 = (ref = images.find((image)=>image.label === FRONT_IMAGE
    )) !== null && ref !== void 0 ? ref : images[0];
    return image1 ? image1 : placeholderImage;
}

/**
 * Checks if we have a `label` and `url` on an image
 */ function isValidImages(imagesArray) {
    return !!imagesArray && imagesArray.some((item)=>item.label && item.url
    );
}

const isModifiedClickEvent = (e)=>e.ctrlKey || e.metaKey || e.altKey || e.shiftKey
;

function createScriptTag(options) {
    const { async , defer , id , src , cb , text  } = options;
    const script = document.createElement('script');
    if (async) {
        script.setAttribute('async', '');
    }
    if (defer) {
        script.setAttribute('defer', '');
    }
    if (id) {
        script.id = id;
    }
    if (src) {
        script.src = src;
    }
    if (cb) {
        script.onload = cb;
    }
    if (text) {
        script.text = text;
    }
    return script;
}
function injectTags(tags) {
    const head = document.head;
    if (head) {
        tags.forEach((tag)=>{
            head.appendChild(tag);
        });
    }
}

const toKm = (meters)=>meters / 1000
;
const toMiles = (meters)=>meters / 1609.344
;
/**
 * Given a value of a type like `SomeType | WithDistance<SomeType>`, check
 * whether the value is of type `SomeType` or of type `WithDistance<SomeType>`.
 */ const hasDistance = (value)=>'distance' in value && typeof value.distance === 'number'
;
/**
 * Format a DistanceInMeters to a string representation in the given DistanceUnit.
 */ const formatDistance = (distance, distanceUnit, options)=>{
    if (typeof distance !== 'number' || distance === Infinity) {
        return '';
    }
    const separator = (options === null || options === void 0 ? void 0 : options.separator) || '';
    // number type check is needed in order to also allow 0 as precision value
    const hasPrecision = typeof (options === null || options === void 0 ? void 0 : options.precision) === 'number';
    /**
   * toFixed returned value conversion to number is needed in order to return
   * integer value when the result is integer, example: return 1km instead of 1.0km
   */ switch(distanceUnit){
        case DistanceUnit.km:
            return `${Number(toKm(distance).toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 1))}${separator}km`;
        case DistanceUnit.mile:
            return `${Number(toMiles(distance).toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 1))}${separator}mi`;
        case DistanceUnit.meter:
            return `${Number(distance.toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 0))}${separator}m`;
        default:
            console.warn(`Unknown distance unit ${distanceUnit}`);
            return distance.toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 0);
    }
};

/**
 * Find each `item`'s geodesic distance to the `reference` (in meters). Returns
 * an array of `[item, distance]` tuples, sorted by distance.
 */ const sortByDistance = (reference, items)=>items.map((item)=>[
            item,
            getDistance(reference, item)
        ]
    ).sort((a, b)=>a[1] - b[1]
    )
;

/**
 * Find the `limit` items that are nearest to the `reference` point on the
 * surface of earth. Returns an array of objects cloned from the original
 * items, with the `distance` in meters added.
 */ const findNearestCoordinates = (reference, items, options = {
    limit: 1
})=>sortByDistance(reference, items).slice(0, options.limit).map(([item, distance])=>swcHelpers.objectSpread({}, item, {
            distance
        })
    )
;

const getDirectionsUrl = ({ streetName , town , opco  })=>{
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([
        ...streetName.split(' '),
        town,
        opco
    ].join(' ').trim())}`;
};
const getMapImageUrl = ({ lat , lon , googleMapsApiKey  })=>{
    return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&zoom=13&size=640x200&scale=2&markers=anchor:28,48|icon:https://assets.grandvision.io/global/store2.png|scale:2%7C${lat},${lon}&mapType=roadmap&key=${googleMapsApiKey}`;
};

const recoverableStatusCodes = new Set([
    500,
    502,
    503,
    429
]);
const shouldRetry = (response)=>{
    if (response.ok) {
        return false;
    }
    // Note, we could add support for https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
    // But support seems minimal as of time of writing
    return recoverableStatusCodes.has(response.status);
};
const httpMethodsWeCanRetry = new Set([
    'GET',
    'PUT',
    'HEAD',
    'DELETE',
    'OPTIONS',
    'TRACE'
]);
const canRetry = (request)=>{
    var ref;
    // Whitelist some HTTP methods
    if (!httpMethodsWeCanRetry.has((ref = request === null || request === void 0 ? void 0 : request.method) !== null && ref !== void 0 ? ref : 'GET')) {
        return false;
    }
    return true;
};
const pause = (time)=>new Promise((resolve)=>{
        setTimeout(()=>resolve()
        , time);
    })
;
const fetchWithTimeout = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(timeout, ...fetchArgs) {
        const controller = new AbortControllerPolyfill();
        const id = setTimeout(()=>{
            controller.abort();
        }, timeout);
        const [requestInfo, requestInit = {}] = fetchArgs;
        /**
   * NB: Casting to lib.d.ts version of AbortSignal because the polyfill doesn't fully support everything
   *     The abort-controller package seems abandoned but nodejs v16 includes native support for AbortController/Signal
   * TODO: nodejs-16 should be able to remove the casting below
   */ const response = yield fetch(requestInfo, swcHelpers.objectSpread({}, requestInit, {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    });
    return function fetchWithTimeout(timeout) {
        return _ref.apply(this, arguments);
    };
}();
const defaultOptions = {
    attempts: [
        // First attempt, allow 10s to respond
        {
            timeout: 10000
        },
        // Wait 2s before trying again, waiting 10s again
        {
            wait: 2000,
            timeout: 10000
        },
        // Wait 5s more seconds for third attempt, leave just 3s for server to respond
        {
            wait: 5000,
            timeout: 3000
        }, 
    ]
};
const resilientFetch = (options)=>{
    const { attempts  } = swcHelpers.objectSpread({}, defaultOptions, options);
    return function() {
        var _ref = swcHelpers.asyncToGenerator(function*(info, init) {
            const url = typeof info === 'string' ? info : info.url;
            // Short-circuit when we can't retry this type of request
            if (!canRetry(init)) {
                return fetch(info, init);
            }
            for(let a = 0; a < attempts.length; a++){
                const attempt = attempts[a];
                // Check if we have to wait before starting attempt
                if (isNumber(attempt.wait)) {
                    console.info(`Retrying ${url} in ${attempt.wait}ms`);
                    yield pause(attempt.wait);
                }
                let response = null;
                try {
                    response = yield fetchWithTimeout(attempt.timeout, info, init);
                } catch (e) {
                    let message = String(e);
                    // Detect local timeout
                    if (e instanceof Error && e.name === 'AbortError') {
                        message = `request took longer than ${attempt.timeout}ms`;
                    }
                    // Log attempt failure except the last attempt.
                    // We'll leave handling the last attempt outside of the loop
                    if (a < attempts.length - 1) {
                        console.warn(`Attempt #${a + 1} to fetch ${url} failed: `, message);
                    }
                }
                if (!response || shouldRetry(response)) {
                    continue;
                }
                return response;
            }
            throw new Error(`Failed to fetch '${url}' after ${attempts.length} attempts`);
        });
        return function(info, init) {
            return _ref.apply(this, arguments);
        };
    }();
};

function useLocalStorage(key, initialValue, shouldRemove = (v)=>v === null
) {
    const [value, setValue] = useState(()=>{
        try {
            if (globalThis.localStorage.hasOwnProperty(key)) {
                const item = globalThis.localStorage.getItem(key);
                if (item !== null) {
                    return JSON.parse(item);
                }
            }
        } catch (err) {
            console.warn('unable to get item from localStorage');
        }
        return initialValue;
    });
    React.useDebugValue(value, (v)=>({
            key,
            value: v
        })
    );
    useEffect(()=>{
        try {
            shouldRemove(value) ? globalThis.localStorage.removeItem(key) : globalThis.localStorage.setItem(key, JSON.stringify(value));
        } catch (err) {}
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
}

function getSessionStorageItem(key) {
    try {
        if (!globalThis.sessionStorage.hasOwnProperty(key)) {
            return null;
        }
        return globalThis.sessionStorage.getItem(key);
    } catch (err) {
        console.warn('unable to get item from sessionStorage');
        return null;
    }
}

function setSessionStorageItem(key, state) {
    try {
        const item = JSON.stringify(state);
        globalThis.sessionStorage.setItem(key, item);
    } catch (err) {
        console.warn(`unable to set item with key: ${key} in sessionStorage`);
    }
}

function useSessionStorage(key, initialValue, shouldRemove = (v)=>v === null
) {
    const [value, setValue] = React.useState(()=>{
        const item = getSessionStorageItem(key);
        if (item !== null) {
            try {
                return JSON.parse(item);
            } catch (e) {
                return initialValue;
            }
        }
        return initialValue;
    });
    React.useDebugValue(value, (v)=>({
            key,
            value: v
        })
    );
    React.useEffect(()=>{
        try {
            shouldRemove(value) ? globalThis.sessionStorage.removeItem(key) : setSessionStorageItem(key, value);
        } catch (err) {}
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
}

const reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return [
                null,
                true,
                null
            ];
        case 'loaded':
            return [
                action.result,
                false,
                null
            ];
        case 'error':
            return [
                null,
                false,
                action.error
            ];
    }
};
function useDynamicModule(loader, name, deps) {
    const [state, dispatch] = React__default.useReducer(reducer, [
        null,
        true,
        null
    ]);
    React__default.useEffect(()=>{
        let current = true;
        dispatch({
            type: 'loading'
        });
        loader().then((mod)=>{
            if (current) {
                dispatch({
                    type: 'loaded',
                    result: mod
                });
            }
        }).catch((error)=>{
            if (current) {
                console.error(`Failed to load dynamic module: ${name}`, error);
                dispatch({
                    type: 'error',
                    error
                });
            }
        });
        return function detach() {
            current = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        name,
        ...deps
    ]);
    return state;
}

const calculateHeaderHeight = ()=>{
    var ref, ref1;
    return ((ref = document === null || document === void 0 ? void 0 : document.querySelector('.header')) === null || ref === void 0 ? void 0 : ref.clientHeight) || //if the regular header height is 0 we check the mobile header
    ((ref1 = document === null || document === void 0 ? void 0 : document.querySelector('.header__header')) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) || 0;
};

const createImageUrl = (url, params = {})=>{
    const options = {
        width: 'w',
        height: 'h',
        backgroundColor: 'bg',
        fit: 'fit',
        format: 'fm'
    };
    const urlParams = Object.entries(params).map(([key, value])=>{
        return `${options[key]}=${value}`;
    });
    return `${url}?${urlParams.join('&')}&auto=format`;
};

const formatHour = (hoursData)=>{
    const validHourRegex = /\d{3,4}/;
    if (!hoursData) {
        return '';
    }
    let hour;
    hour = hoursData.toString();
    hour = hour.length === 3 ? `0${hour}` : hour;
    if (validHourRegex.test(hour)) {
        const hours = hour.length === 4 ? hour.slice(0, 2) : `0${hour.slice(0, 1)}`;
        const minutes = hour.length === 4 ? hour.slice(2) : hour.slice(1);
        return `${hours}:${minutes}`;
    } else {
        return 'unknown';
    }
};

const getNestedProperty = (// Wondering if this function is still necessary with optional chaining being available now.
// eslint-disable-next-line @typescript-eslint/ban-types
obj1, path, defaultValue)=>{
    if (!obj1 || !path) {
        return defaultValue || undefined;
    }
    const pathArray = path.split('.');
    const result = pathArray.reduce((obj, prop)=>{
        return obj && obj[prop] ? obj[prop] : null;
    }, obj1);
    return result || defaultValue || undefined;
};

const getLocalizedValue = (attribute, locale)=>{
    if (!isPlainObject(attribute)) {
        return '';
    }
    const language = locale.substr(0, 2);
    let attr = attribute;
    // CT Enum has a definition of key and label inside value
    if (attribute.hasOwnProperty('key') && attribute.hasOwnProperty('label')) {
        attr = attribute.label;
    }
    const result = attr[locale] || attr[language] || getNestedProperty(attr, 'en') || '';
    if (isPlainObject(result)) {
        return '';
    }
    return result;
};
const getLocalizedValues = (attributes, locale)=>{
    if (!Array.isArray(attributes)) {
        return [];
    }
    return attributes.map((attr)=>getLocalizedValue(attr, locale)
    );
};

const findAttribute = (input, attrName)=>input && input.attributes ? input.attributes.find((attr)=>attr.name === attrName
    ) : undefined
;
const getAttrValue = (input, attrName)=>{
    const attr = findAttribute(input, attrName);
    // CT Enum has a definition of key and label inside value
    if (isPlainObject(attr) && attr.value && attr.value.hasOwnProperty('key') && attr.value.hasOwnProperty('label')) {
        return attr.value.label;
    }
    return attr && attr.value;
};
const getLocalizedAttrValue = (input, attrName, locale)=>{
    const attr = getAttrValue(input, attrName);
    if (!isPlainObject(attr)) {
        return '';
    }
    return getLocalizedValue(attr, locale);
};
const getLocalizedAttrValues = (input, attrName, locale)=>{
    const attr = getAttrValue(input, attrName);
    if (!Array.isArray(attr)) {
        return [];
    }
    return getLocalizedValues(attr, locale);
};
/**
 * If attribute is an array, return it joined by the separator, otherwise just the string.
 */ const getJoinedLocalizedAttrValues = (input, attrName, locale, separator = ', ')=>{
    const attr = getAttrValue(input, attrName);
    if (isPlainObject(attr)) {
        return getLocalizedValue(attr, locale);
    }
    if (Array.isArray(attr)) {
        var ref;
        var ref1;
        return (ref1 = (ref = getLocalizedValues(attr, locale)) === null || ref === void 0 ? void 0 : ref.join(separator)) !== null && ref1 !== void 0 ? ref1 : '';
    }
    return '';
};

const visitorObject = Type.interface({
    id: Type.string,
    header: Type.string,
    new: optional(Type.boolean)
});
const legacyIdFormat = /^[\w]{8}-[\w]{4}-[\w]{4}-[\w]{4}-[\w]{12}/;
function parseVisitorId(cookieContent) {
    if (!cookieContent) {
        return;
    }
    // check for the legacy cookie format as users might still have it in their browser
    if (legacyIdFormat.test(cookieContent)) {
        return cookieContent;
    }
    try {
        const result = verify(visitorObject, JSON.parse(cookieContent));
        if (!result.err) {
            return result.value();
        }
        console.warn('Failed to parse Bloomreach Visitor cookie.', result.err);
    } catch (error) {
        console.warn('Failed to parse Bloomreach Visitor cookie.', error);
    }
    return;
}

const optionalKey = (key, value)=>{
    if (!value || value === {} || value === '') {
        return;
    }
    if (value instanceof Object && Object.values(value).every((v)=>v === ''
    )) {
        return;
    }
    return {
        [key]: value
    };
};

const PRESCRIPTION_SORTING_ARRAY = [
    'power',
    'baseCurve',
    'diameter',
    'cylinder',
    'axis',
    'addition',
    'pupillaryDistance', 
];
function sortPrescriptionParameters(paramNames) {
    const knownParams = paramNames.filter((p)=>PRESCRIPTION_SORTING_ARRAY.includes(p)
    );
    const unknownParams = paramNames.filter((p)=>!PRESCRIPTION_SORTING_ARRAY.includes(p)
    );
    const sortedParams = knownParams.sort((a, b)=>PRESCRIPTION_SORTING_ARRAY.indexOf(a) - PRESCRIPTION_SORTING_ARRAY.indexOf(b)
    );
    const sortedUnknownParams = unknownParams.sort();
    return [
        ...sortedParams,
        ...sortedUnknownParams
    ];
}

/**
 * Allows to bind a handler to the beforeunload event
 * @example
 *  const clearSessionStorage = (e) => globalThis.sessionStorage.clear('item')
 *  useBeforeunload(clearSessionStorage)
 */ const useBeforeunload = (handler)=>{
    React__default.useEffect(()=>{
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('beforeunload', handler);
        return ()=>window.removeEventListener('beforeunload', handler)
        ;
    }, [
        handler
    ]);
};

/**
 * If we want to make sure a effect is run on first render,
 * so simultaneous with the DOM rendering,
 * but also make sure frameworks like NextJS stay functional we can check for window and return the correct effect.
 *
 * https://reactjs.org/link/uselayouteffect-ssr Some common fixes and comments can be found here.
 */ const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

function useInterval(callback, delay, options = {}) {
    const { when =true , startImmediate =false  } = options;
    const savedCallback = useRef();
    // Make sure we save the specified callback as soon as possible (browser will use useLayoutEffect)
    useIsomorphicLayoutEffect(()=>{
        savedCallback.current = callback;
    }) // No dependency array as we want to update the callback every render and not every reference change.
    ;
    // Set up the interval.
    useEffect(()=>{
        function tick() {
            var ref;
            (ref = savedCallback.current) === null || ref === void 0 ? void 0 : ref.call(savedCallback);
        }
        if (when) {
            if (startImmediate) {
                tick();
            }
            if (isNotNull(delay)) {
                const id = setInterval(tick, delay);
                return ()=>{
                    clearInterval(id);
                };
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        delay,
        when
    ]) // Note: startImmediate is explicitly omitted from the dep array as that should only have effect once
    ;
}

function withLazyLoading(Component, options) {
    const { rootMargin ='150px 0px' , className , classNameAfterLoad ='' , classNameBeforeLoad ='' , ['data-t']: dataT ,  } = options || {};
    const wrappedName = Component.displayName || Component.name || 'Component';
    const withLazyLoading1 = (props)=>{
        const [inViewRef, inView] = useInView({
            rootMargin,
            triggerOnce: true
        });
        const containerClassName = classnames('lazy-loading', className, [
            {
                [`${classNameBeforeLoad}`]: !inView,
                [`${classNameAfterLoad}`]: inView
            }, 
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            className: containerClassName,
            ref: inViewRef,
            "data-t": dataT
        }, inView ? /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props)) : null);
    };
    withLazyLoading1.displayName = `WithLazyLoading(${wrappedName})`;
    return withLazyLoading1;
}

/**
 * Extracts the current route part from a pathname
 * EG: `/my-account/profile/subscriptions/12345`
 * will return a currentRoute of `profile/subscriptions/12345`
 *
 * EG: `/checkout/shipping`
 * will return a currentRoute of `shipping`
 *
 * For multilingual
 * EG: `/en_GB/book-appointment/type`
 * will return a currentRoute of `type`
 *
 * Also supports query params and hash fragments
 * EG: `/my-account/callback#access_token`
 * will return a currentRoute of `callback`
 *
 * EG: `/my-account/login?returnPath=path`
 * will return a currentRoute of `login`
 */ function extractCurrentRoute(path, locale) {
    // Path is a relative URL so we need to add a random base URL here to make URL() work
    const { pathname  } = new URL(path, 'https://not.used/');
    var ref;
    const parts = (ref = pathname.split('/')) !== null && ref !== void 0 ? ref : [];
    // If a site is multilingual and the url contains the locale (which it should)
    // we should skip one more part before we join the rest of the url parts together
    const skip = locale && pathname.includes(`/${locale.replace('-', '_')}`) ? 3 : 2;
    return parts.slice(skip).join('/');
}

// This multiplies a number by the exponent of the amount of decimals such as
// 1.00155e3 (1.00155 * 10^3 = 1001.55) then rounds it (1002), and then string concats it
// to the negative exponent 1002e-3 (1002 * 10^-3 = 1.002) to reduce it to the required decimal.
// It needs to use this somewhat clunky string conversion to avoid doing any arithmetic.
const roundNumber = (value, decimals)=>{
    return Number(`${Math.round(parseFloat(`${value}e${decimals}`))}` + `e-${decimals}`);
};

// Generates a range of numbers from start to stop with an optional increment
const createNumberRange = (start, stop, increment = 1, digits = 0)=>{
    const a = [
        start
    ];
    let b = start;
    if (stop <= start) {
        throw new Error('Start must be smaller than stop');
    }
    if (increment <= 0) {
        throw new Error('Increment must be greater than zero');
    }
    if (increment < 1 && digits === 0) {
        throw new Error('You need to provide digits when increment is smaller than 1');
    }
    while(roundNumber(b, digits) < stop){
        a.push(roundNumber(b += increment, digits));
    }
    return a;
};

const parseHtml = (html, options)=>parse$1(html, options)
;
const domToReact = (nodes)=>domToReact$1(nodes)
;

var /**
 * TODO:
 * `Currencies` is a duplicate of `packages/state/src/Intl/IntlContext/IntlContext.tsx`
 *
 * We can't import these from the `state` package, because of cyclic dependency errors.
 * The best approach would be to create a separate package to host all the `Intl` configuration.
 */ Currencies;
(function(Currencies) {
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["USD"] = "USD";
    Currencies["SEK"] = "SEK";
    Currencies["DKK"] = "DKK";
})(Currencies || (Currencies = {}));
const CURRENCIES = Object.keys(Currencies);
const DEFAULT_CURRENCY = Currencies.EUR;
const DEFAULT_FORMAT = '--';
const formatPrice = ({ locale , value , currency , isCentAmount  })=>{
    if (value === undefined || isNaN(value)) {
        return DEFAULT_FORMAT;
    }
    var ref;
    // Only use supported currencies or fallback to default currency
    const priceCurrency = (ref = Currencies[currency || '']) !== null && ref !== void 0 ? ref : DEFAULT_CURRENCY;
    const number = isCentAmount ? value / 100 : value;
    const fractionDecimals = !isCentAmount || value % 100 === 0 ? 0 : 2;
    const price = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: priceCurrency,
        minimumFractionDigits: fractionDecimals,
        maximumFractionDigits: fractionDecimals
    }).format(number);
    return price;
};

const sanitizeStringForUrl = (brand = '')=>deburr(brand// replace unwanted characters with a space
    .replace(/['"`´‘’!.&_\-\+]+/gi, ' ').trim().toLowerCase()// replace all consecutive whitespace characters with a dash
    .replace(/\s+/gi, '-'))
;

function calculateVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    requestAnimationFrame(calculateVh);
}
const useAddViewportHeightCssVariable = ()=>{
    React__default.useEffect(()=>{
        // if already --vh is applied on body, do nothing
        if (document.documentElement.style.getPropertyValue('--vh')) {
            console.warn('Viewport height css variable `--vh` not applied to document, variable has already been set');
            return;
        }
        requestAnimationFrame(calculateVh);
        window.addEventListener('resize', calculateVh);
        window.addEventListener('orientationchange', calculateVh);
        // Cleanup event listeners
        return ()=>{
            window.removeEventListener('resize', calculateVh);
            window.removeEventListener('orientationchange', calculateVh);
            document.documentElement.style.removeProperty('--vh');
        };
    }, []);
};

/**
 * Can't use formatPrice, because apple only accepts American notation without a currency symbol.
 **/ const convertCentsToDecimalString = (cents)=>`${(cents / 100).toFixed(2)}`
;

const getUpdatedUrlWithQueryParams = (params)=>{
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    params && Object.keys(params).forEach((key)=>{
        params[key] && urlParams.set(key, `${params[key]}`);
    });
    return url.toString();
};
const appendQueryParamToUrl = (path, params)=>{
    const url = new URL(`${window.location.origin}${path}`);
    const urlParams = url.searchParams;
    params && Object.keys(params).forEach((key)=>{
        params[key] && urlParams.set(key, `${params[key]}`);
    });
    return url.toString();
};
const removeQueryParamsFromUrl = (params)=>{
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    params.forEach((paramKey)=>{
        urlParams.delete(paramKey);
    });
    return url.toString();
};

const useGetQueryParams = ()=>{
    return typeof window !== 'undefined' ? parse(window.location.search.substring(1)) : {};
};

const updateUrlWithoutReload = (url)=>{
    if (window.history) {
        window.history.replaceState({
            path: url
        }, window.document.title, url);
    }
};
const updateUrlWithReload = (url)=>{
    if (window.history) {
        window.history.pushState({
            path: url
        }, window.document.title, url);
    }
};

const getLocalizedString = (localizedStrings, locale)=>{
    var ref;
    let value = (ref = localizedStrings === null || localizedStrings === void 0 ? void 0 : localizedStrings.find((string)=>string.locale === locale
    )) === null || ref === void 0 ? void 0 : ref.value;
    // Business rule, localized version unavailable, try 'en' fallback
    if (value === undefined) {
        var ref1;
        value = (ref1 = localizedStrings === null || localizedStrings === void 0 ? void 0 : localizedStrings.find((string)=>string.locale.substr(0, 2) === 'en'
        )) === null || ref1 === void 0 ? void 0 : ref1.value;
    }
    return value || '';
};

export { CURRENCIES, cookies as Cookies, dateUtils as DateUtils, DistanceUnit, environmentUtils as EnvironmentUtils, localeUtils as LocaleUtils, formatPrescriptionValue$1 as PrescriptionValueUtils, query as QueryString, stringGuard as StringGuard, index as StringUtils, WithUserCoords, appendQueryParamToUrl, calculateHeaderHeight, convertCentsToDecimalString, createImageUrl, createNumberRange, createScriptTag, domToReact, extractCurrentRoute, findNearestCoordinates, formatDistance, formatHour, formatPrice, getAttrValue, getCenter, getCoords, getDirectionsUrl, getDistance, getFrontImage, getJoinedLocalizedAttrValues, getLocalizedAttrValue, getLocalizedAttrValues, getLocalizedString, getLocalizedValue, getLocalizedValues, getMapImageUrl, getNestedProperty, getSessionStorageItem, getUpdatedUrlWithQueryParams, hasDistance, injectTags, isArray, isBoolean, isDefined, isFunction, isModifiedClickEvent, isNil, isNotNull, isNumber, isPlainObject, isPresent, isString, isValidImages, optionalKey, parseHtml, parseVisitorId, placeholderImage, removeQueryParamsFromUrl, replaceWhitespace, resilientFetch, roundNumber, sanitizeStringForUrl, setSessionStorageItem, slugify, sortPrescriptionParameters, toKm, toMiles, unspaceString, updateUrlWithReload, updateUrlWithoutReload, useAddViewportHeightCssVariable, useBeforeunload, useDebouncedEffect, useDynamicModule, useEventListener, useGetQueryParams, useInterval, useLocalStorage, useScrollIntoView, useSessionStorage, withLazyLoading, withPlusSign };
//# sourceMappingURL=index.js.map
